import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'md', 
  className = '' 
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  };

  return (
    <div className={`animate-spin rounded-full border-2 border-gray-600 border-t-blue-600 ${sizeClasses[size]} ${className}`} />
  );
};

// Loading skeleton for client cards
export const ClientCardSkeleton: React.FC = () => {
  return (
    <div className="px-6 py-4 animate-pulse">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="flex items-center space-x-4">
            <div className="w-10 h-10 bg-gray-700 rounded-full animate-shimmer"></div>
            <div className="space-y-2">
              <div className="h-4 bg-gray-700 rounded animate-shimmer w-32"></div>
              <div className="flex space-x-4">
                <div className="h-3 bg-gray-700 rounded animate-shimmer w-24"></div>
                <div className="h-3 bg-gray-700 rounded animate-shimmer w-20"></div>
                <div className="h-3 bg-gray-700 rounded animate-shimmer w-28"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <div className="w-8 h-8 bg-gray-700 rounded-lg animate-shimmer"></div>
          <div className="w-8 h-8 bg-gray-700 rounded-lg animate-shimmer"></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
